// extracted by css-extract-rspack-plugin
export default {"taskTemplateDivider":"MultipleTasksCandidatesTable_taskTemplateDivider__bNu2f","todoAssigneePicker":"MultipleTasksCandidatesTable_todoAssigneePicker__CVzt9"};